import React from 'react';
import styles from './index.module.scss';

interface IDropDown {
    title?: string;
    value?: string;
    onChange: Function;
    options: {name: string; value: string}[];
    containerClass?: string;
    selectInputProps?: any;
}
const DropDown = (props: IDropDown) => {
  const { title, value, onChange, options = [], containerClass = '', selectInputProps={}} = props;

  const renderOptions = () => {
    return options?.map((option, i)=>{
      return <option key={`${i}`} value={option?.value}>{option?.name}</option>;
    });
  };
  
  return(
    <div className={`${styles['input-group']} ${containerClass}`}>
      <div className={styles['label']}>{title}</div>
      <select
        value={value}
        className={'form-control'}
        onChange={e => onChange(e.target.value)}
        {...selectInputProps}
      >
        {renderOptions()}
      </select>
    </div>
  );
};

export default DropDown;